import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
export default function CategoryController({
  loading,
  allCats,
  selectedCat,
  _callback,
  className,
}) {

  return (
    <div className="autocomplete">
      <Autocomplete
        className={`${className}`}
        loading={loading}
        value={selectedCat}
        id="cats-standard"
        filterSelectedOptions
        options={allCats ? allCats : []}
        getOptionLabel={(option) => option.nameRu}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.nameRu}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} color="primary" size="large" variant="outlined" />
        )}
        onChange={(e, target) => {
          _callback(target);
        }}
      />
    </div>
  );
}
